import store from '@/store/store';
import { trackEvent } from '@/plugins/mixpanel';

export const trackEventWithUserProperties = (eventName, properties = {}) => {
  const dashboardId = store.getters['dashboard/activeDashboard'].id;
  const userType = store.getters['user/userType'];

  const newProperties = {
    ...properties,
    dashboardId,
    userType,
  };

  trackEvent(eventName, newProperties);
};
